import EmblemProps from './types';

function validateProps(props: EmblemProps) {
  let isValid = true;
  Object.keys(props).forEach((key) => {
    const value = props[key as keyof EmblemProps];
    if (typeof value !== 'string') {
      console.error(`Invalid prop ${key}: expected string, got ${typeof value}`);
      isValid = false;
    }
  });

  if (!props.url) {
    console.error('Invalid props: missing required prop url');
    isValid = false;
  }

  if (!props.projectKey) {
    console.error('Invalid props: missing required prop projectKey');
    isValid = false;
  }

  if (!props.state) {
    console.error('Invalid props: missing required prop state');
    isValid = false;
  }

  return isValid;
}

export default validateProps;
